export const baseMenu = [
  { icon: "mdi-home", text: "main", link: "/" },
  { icon: "mdi-account-clock", text: "Scheduler", link: "Scheduler" },
  { icon: "mdi-pill", text: "need", link: "Order", },
];

export const chatMenu = {
  id: "chat",
  icon: "mdi-chat",
  text: "farmChat",
  link: "Chat",
  badge: 0 // будем брать из Vuex
};

export const ordersMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "orders",
  model: false,
  children: [
    { icon: "mdi-pill", text: "need", link: "Order" },
    { icon: "mdi-archive-arrow-down-outline", text: "archive", link: "ArchivePharmacy" },
    { icon: "mdi-sale", text: "discounts", link: "Discount" }
  ]
};

export const directoryMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "directory",
  model: false,
  children: [
    { icon: "mdi-city-variant", text: "cities", link: "City" },
    { icon: "mdi-truck-delivery", text: "suppliers", link: "Distributor" },
    { icon: "mdi-hospital-box", text: "goods", link: "Goods" },
    { icon: "mdi-book-open", text: "annotation", link: "Annotation" },
    { icon: "mdi-note-multiple", text: "pricesMenu", link: "Price" },
    { icon: "mdi-account-group", text: "users", link: "User"}
  ]
};

export const controlMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "control",
  model: false,
  children: [
    { icon: "mdi-account-switch", text: "users", link: "UserControl" },
    { icon: "mdi-domain", text: "companies", link: "CompanyControl" },
    { icon: "mdi-domain", text: "access", link: "AccessControl" },
    { icon: "mdi-domain", text: "accessTemplate", link: "AccessTemplateControl" },
    { icon: "mdi-domain", text: "advertising", link: "AdControl" },
    { icon: "mdi-domain", text: "orders", link: "OrderControl" },
    { icon: "mdi-google-analytics", text: "discountsAndContracts", link: "ContractControl" },
    { icon: "mdi-google-analytics", text: "shippingAddresses", link: "ShippingAddressControl" },
    { icon: "mdi-google-analytics", text: "halykCards", link: "HalykCardsControl" },
    { icon: "mdi-google-analytics", text: "pricesMenu", link: "PriceControl" },
    { icon: "mdi-google-analytics", text: "suppliers", link: "DistributorControl" },
    { icon: "mdi-google-analytics", text: "Hangfire", link: "Hangfire" },
    { icon: "mdi-google-analytics", text: "apirequest", link: "apirequestcontrol" },
    { icon: "mdi-newspaper-variant-outline", text: "news", link: "Article" },
    { icon: "mdi-newspaper-variant-outline", text: "UserAccess", link: "UserAccessControl" }
  ]
};

export const settingsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "setting",
  model: false,
  children: [
    { icon: "mdi-album", text: "priorities", link: "FilialLine", },
    { icon: "mdi-cog", text: "generalSettings", link: "UserSettings", },
  ],
};

export const reportsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "reports",
  model: false,
  children: [
    { icon: "mdi-chart-bar", text: "priceMonitoring", link: "PriceAnalysisReport", },
    { icon: "mdi-chart-bar", text: "averagePriceReport", link: "AveragePriceShareSalesReport", },
  ],
}

// Утилита для клонирования и удаления элементов по text
export function cloneMenu(menu, exclude = []) {
  return {
    ...menu,
    children: menu.children.filter(c => !exclude.includes(c.text))
  }
}